import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { SectionTitle } from "../Eyebrow";

export const formatPostDate = (iso) =>
    iso ? new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "short", year: "numeric" }) : "";

export const LatestArticles = () => {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        api.get("/blog").then(({ data }) => setPosts((data || []).slice(0, 3))).catch(() => {});
    }, []);

    if (!posts.length) return null;
    return (
        <section
            data-testid="home-latest-articles"
            aria-labelledby="latest-articles-heading"
            className="mx-auto max-w-[1240px] px-4 md:px-8 lg:px-12 py-10 md:py-16 lg:py-20 flex flex-col gap-5 md:gap-7"
        >
            <div className="flex flex-wrap justify-between items-end gap-x-3 gap-y-1">
                <SectionTitle className="!m-0">
                    <span id="latest-articles-heading">Nos derniers décryptages</span>
                </SectionTitle>
                <Link to="/actualites" data-testid="home-articles-more" className="text-[15px] font-semibold text-navy underline underline-offset-4 hover:text-gold-text inline-flex items-center min-h-[44px]">
                    Voir tous les articles
                </Link>
            </div>
            <div data-testid="home-articles-track" className="-mx-4 px-4 md:mx-0 md:px-0 flex md:grid md:grid-cols-3 gap-4 md:gap-5 overflow-x-auto md:overflow-visible snap-x snap-mandatory scroll-px-4 pb-2 md:pb-0 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
                {posts.map((p) => (
                    <Link
                        key={p.id}
                        to={`/post/${p.slug}`}
                        data-testid={`home-article-${p.slug}`}
                        className="group snap-start shrink-0 w-[84%] md:w-auto flex flex-col gap-3 bg-white border border-border-default rounded-xl p-6 text-navy transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-lg"
                    >
                        <span className="text-[13px] md:text-xs font-semibold uppercase tracking-[0.12em] text-gold-text">
                            {[p.category, formatPostDate(p.created_at)].filter(Boolean).join(" · ")}
                        </span>
                        <span className="text-lg font-bold leading-[1.35] group-hover:text-gold-text transition-colors">{p.title}</span>
                    </Link>
                ))}
            </div>
        </section>
    );
};
